import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=2bcc2751&scoped=true&lang=pug&"
import script from "./AppFooter.vue?vue&type=script&lang=js&"
export * from "./AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=2bcc2751&lang=scss&scoped=true&"
import style1 from "./AppFooter.vue?vue&type=style&index=1&theme=cwo&lang=scss&"
import style2 from "./AppFooter.vue?vue&type=style&index=2&theme=ffc&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc2751",
  null
  
)

export default component.exports